import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import useOperationTranslation from "../../../hooks/useOperationTranslation";

interface Props {
  setOpenDownloadModal: () => void;
};

const ExportDamageForms = (props: Props) => {
    const t = useOperationTranslation();

    return(
      <Mui.Dialog open={true} maxWidth={"md"}>
      <Mui.DialogTitle>
        <Mui.Grid container alignItems="center" direction="row" spacing={1}>
          <Mui.Grid item sx={{ display: "flex" }}>
            <MuiIcons.CheckCircle sx={{ color: "green" }} />
          </Mui.Grid>

          <Mui.Grid xs item>
            <Mui.Typography variant="h5">
              {t("damageForm.details.dialogs.downloadModal.title")}
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item sx={{ justifyContent: "flex-end", display: "flex" }}>
            <MuiIcons.Close
              color="disabled"
              fontSize="small"
              onClick={props.setOpenDownloadModal}
            />
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>
      <Mui.DialogContent>
        <Mui.Box>{t("damageForm.details.dialogs.downloadModal.body")}</Mui.Box>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Grid
          container
          alignItems="center"
          alignContent="center"
          direction="row"
        >
          <Mui.Grid>
            <Mui.Link href="/operation/damages/damageFormExport">
              {t("damageForm.details.dialogs.downloadModal.footer")}
            </Mui.Link>
          </Mui.Grid>
          <Mui.Grid
            xs
            item
            sx={{ display: "flex", justifyContent: "flex-end" }}
            pr={2}
          >
            <Mui.Stack direction="row" spacing={2.5}>
              <Mui.Button onClick={props.setOpenDownloadModal}>
                <Mui.Typography variant="h6" color="inherit">
                  {t("actionButtons.close")}
                </Mui.Typography>
              </Mui.Button>
            </Mui.Stack>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
}

export default ExportDamageForms;